module.exports = __webpack_public_path__ + "71154f2f0aa8043339a51ce90e2b161b.svg";